var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecentMeditationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91667 20C7.15741 20 4.81482 19.0231 2.88889 17.0694C0.962963 15.1157 0 12.75 0 9.97222H1.66667C1.66667 12.287 2.46296 14.2593 4.05556 15.8889C5.64815 17.5185 7.60185 18.3333 9.91667 18.3333C12.2685 18.3333 14.2593 17.5093 15.8889 15.8611C17.5185 14.213 18.3333 12.213 18.3333 9.86111C18.3333 7.56482 17.5093 5.625 15.8611 4.04167C14.213 2.45833 12.2315 1.66667 9.91667 1.66667C8.65741 1.66667 7.47685 1.9537 6.375 2.52778C5.27315 3.10185 4.31482 3.86111 3.5 4.80556H6.41667V6.47222H0.611111V0.694444H2.27778V3.63889C3.24074 2.50926 4.38426 1.62037 5.70833 0.972222C7.03241 0.324074 8.43519 0 9.91667 0C11.3056 0 12.6111 0.259259 13.8333 0.777778C15.0556 1.2963 16.125 2.00463 17.0417 2.90278C17.9583 3.80093 18.6806 4.85185 19.2083 6.05556C19.7361 7.25926 20 8.55556 20 9.94444C20 11.3333 19.7361 12.6389 19.2083 13.8611C18.6806 15.0833 17.9583 16.1481 17.0417 17.0556C16.125 17.963 15.0556 18.6806 13.8333 19.2083C12.6111 19.7361 11.3056 20 9.91667 20ZM13.4722 14.5278L9.19444 10.3056V4.36111H10.8611V9.61111L14.6667 13.3333L13.4722 14.5278Z",
    fill: "#4B2B5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentMeditationIcon);
export default __webpack_public_path__ + "static/media/recentMeditationIcon.0deef69c469b04617583126f152b395e.svg";
export { ForwardRef as ReactComponent };